import { ScheduleReport } from '@library/modules/reports/schedule-report/schedule-report';
import { randRecentDate, randNumber, randFullName, randWord, randEmail, randTimeZone, randSoonDate, randBoolean, rand } from '@ngneat/falso';

export class MockScheduleReports extends ScheduleReport {
   id: any;
   schedule_name: string;
   schedule_description: any;
   startDate: any;
   endDate: any;
   recurrence_period: string;
   frequency_week: any;
   frequency_month: any;
   timezone: string;
   no_end_date: boolean;
   active: boolean;
   startTime: string;
   recipients: { recipient_name: string; recipient_email: string; }[];
   report_name: string;
   constructor() {


      super({
          id : randNumber({min:1, max:999}),
          recurrence_period : rand(['daily', 'weekly', 'monthly']),
          startTime : randRecentDate().toISOString().slice(11, 16),
          startDate : randSoonDate({days:2}).toString(),
          endDate : randSoonDate({days:10}).toString(),
          no_end_date : randBoolean(),
          recipients : Array.from({ length: randNumber({ min: 1, max: 6 }) }, _ => ({ 'recipient_name': randFullName(), 'recipient_email': randEmail() })),
          frequency_week : Array.from({ length: randNumber({ max: 6 }) }, ()=> randNumber({ min: 0, max: 6 }) ),
          frequency_month : Array.from({ length: randNumber({ max: 10 }) }, ()=> randNumber({ min: 1, max: 30 }) ),
          timezone : randTimeZone(),
          schedule_name : randWord(),
          schedule_description : randWord({length:5}).join( ' ' ),
          status : randBoolean(),
          report_name: randWord()
      });

   }
}
